<template>
  <v-layout row wrap class="user-block" v-if="profile && profile.id">
    <v-flex xs12>
      <v-icon account_box>account_box</v-icon>
    </v-flex>
    <v-flex xs12 class="user-name">
      {{profile.name}}
    </v-flex>
    <v-flex xs12>
      {{profile.email}}
    </v-flex>
    <v-flex xs12 class="user-farm-name">
      {{profile.organization.name}}
    </v-flex>
    <div @click="handleChangePassword" class="small-btn primary--text">
      Change Password
    </div>
    <div @click="handleLogout" class="small-btn primary--text">
      Logout
    </div>
  </v-layout>
</template>

<script>

import { mapGetters } from 'vuex'

export default {
  name: 'UserInfo',
  computed: mapGetters(['profile']),
  methods: {
    handleLogout () {
      this.$emit('on-logout')
    },
    handleChangePassword () {
      this.$emit('on-change-password')
    }
  }
}

</script>

<style lang="scss" scoped>
.user-block{
  border: 1px solid #378e07;
  border-radius: 4px;
  padding: 14px 18px;
  margin: auto 17px;
  font-size: 14px;
  .user-name{
    font-family: 'Roboto';
    font-weight: 500;
  }
  .user-farm-name{
    opacity: .5;
  }
  .small-btn{
    padding-top: 5px;
    cursor: pointer;
  }
}
</style>
